module.exports = __webpack_public_path__ + "assets/img/project-blob-left.0d8b8b49.webp";